module.exports = __webpack_public_path__ + "img/rating.d16747b0.svg";